module.exports = __webpack_public_path__ + "static/media/success_hand_ticket.a367e573.png";